import { render, staticRenderFns } from "./NewArticlePage.vue?vue&type=template&id=2517764c&"
import script from "./NewArticlePage.vue?vue&type=script&lang=js&"
export * from "./NewArticlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports